import { getAngleDeviationEventContent } from "@/features/presets/analytics"
import { includes } from "@/libs/lodash"
import { analytics } from "@/libs/telemetry"
import { type Detections } from "./detector"
import { ANGLE_DEVIATION_STAGES, STAGE } from "./stages"

export function sendAnalytics({
  stage,
  detections,
}: {
  stage: STAGE
  detections: Detections | null
}) {
  if (
    stage === STAGE.CAPTURING_DONE ||
    stage === STAGE.ROTATING_LEFT ||
    stage === STAGE.ROTATING_RIGHT
  )
    return

  if (
    stage === STAGE.CAPTURING_LEFT ||
    stage === STAGE.CAPTURING_RIGHT ||
    stage === STAGE.CAPTURING_FRONT
  ) {
    analytics.face_placed_correctly({
      event_content:
        (stage === STAGE.CAPTURING_FRONT && "front") ||
        (stage === STAGE.CAPTURING_LEFT && "left") ||
        "right",
    })

    return
  }

  if (!includes(ANGLE_DEVIATION_STAGES, stage)) {
    analytics[stage]({ timestamp: Date.now() })

    return
  }

  const eventContent = getAngleDeviationEventContent({
    isYaw: stage === STAGE.FACE_YAW_ANGLE_DEVIATION,
    detections,
  })

  analytics.face_angle_deviation({
    timestamp: Date.now(),
    ...(eventContent ? { event_content: eventContent } : {}),
  })
}
